export const sliceText = (text, requiredLength) => {
  if (text?.length) {
    if (text.length > requiredLength) {
      text = `${text.substring(0, requiredLength)}...`;
    }
  }

  return text;
};
